import { z } from 'zod'

import { HTTP_METHOD } from '@nxt-insurance/api-service'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'
import { sanityImageUrlBuilder } from '@helpers/sanity'

const dental_previous_insurer = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('previous_insurer')]: z.string().min(1),
    }),
    showOrderSummary: true,
    onPrepare: {
      type: 'simpleHook',
      callback: async () => {
        const response = await params.clientHelpers.apiService.call({
          serviceName: 'personalizationService',
          method: HTTP_METHOD.GET,
          url: `/api/v1/wallet/insurance_brands?market=${params.clientHelpers.getMarket()}`,
        })

        const dentalBrands = response.data.filter((brands: any) => {
          return brands.categories.includes('dental')
        })

        return {
          formValues: {
            [params.helperFunctions.getTransientPath('insurer_brands')]: dentalBrands,
          },
        }
      },
    },
    stepContent: [
      {
        type: 'searchableList',
        name: params.helperFunctions.getParamPath('previous_insurer'),
        title: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_previous_insurer.title',
        },
        searchPlaceholder: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_previous_insurer.searchPlaceholder',
        },
        popularOptions: ['barmenia_gothaer', 'allianz', 'ottonova', 'dentolo'],
        options: params.helperFunctions.getTransientPath('insurer_brands'),
        optionsTransformer: (insurers = []) => {
          return insurers.map((insurer: { key: string; name: string; logo?: { asset: any } }) => ({
            value: insurer.key,
            label: { type: 'nonTranslatableText' as const, text: insurer.name },
            ...(insurer.logo
              ? { image: sanityImageUrlBuilder(insurer.logo).url() ?? '' }
              : { icon: 'Bank' }),
          }))
        },
      },
    ],
    subFlow: SubFlow.Common,
    nextStep: 'dental_coverage_dates',
  }) as const satisfies AnyStepConfiguration

export default dental_previous_insurer
